<template>
	<div class="content-i">

		<div class="content-box">
			<div class="os-tabs-w">
				<div class="os-tabs-controls os-tabs-complex">
					<ul class="nav nav-tabs">
						<li class="nav-item">
							<a aria-expanded="false" class="nav-link active" data-toggle="tab" href="#tab_overview">
								<span class="tab-label">{{ t.navigation.sport_bets }} </span>
								<span class="tab-value">{{ getAmountMoney ('played_sport_bet_total_amount') }}</span>
								<span class="badge":class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'badge-success' : 'badge-danger'"><i :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'os-icon os-icon-arrow-up6' : 'os-icon os-icon-arrow-down6'"></i><span>{{ getPercentageChangeAmount('played_sport_bet_total_amount') }}%</span></span>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-7 col-xxl-6">

				</div>

			</div>

			<div class="element-wrapper compact pt-4">
				<div class="element-actions">
					<form class="form-inline justify-content-sm-end">
						<label class="smaller" for="">Order By</label>
						<select class="form-control form-control-sm form-control-faded" v-model="selectedAccountingPeriod">
							<option v-for="option in accountingPeriods" v-bind:value="option.value">
								{{ t.filter.accounting[option.value] }}
							</option>
						</select>
					</form>
				</div>
				<h6 class="element-header">
					{{ t.navigation.financial_overview }}
				</h6>
				<div class="element-box-tp">
					<div class="row">
						<div class="col-sm-12 col-lg-8 col-xxl-6">
							<div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.total_amount_of_wager }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.total_amount_of_wager"></i>
									</div>
									<div class="balance-value" v-tooltip="getAmountMoney('played_sport_bet_total_amount', 1)">
										<span class="d-xxl-none">{{ getAmountMoney ('played_sport_bet_total_amount') }}</span>
										<span class="d-none d-xxl-inline-block">{{ getAmountMoney ('played_sport_bet_total_amount') }}</span>

										<span v-if="getPercentageChangeAmount('played_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('played_sport_bet_total_amount') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.net_profit }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.net_profit"></i>
									</div>
									<div class="balance-value" v-tooltip="getNetProfitMoney(1)">
										<span class="d-xxl-none">{{ getNetProfitMoney() }}</span>
										<span class="d-none d-xxl-inline-block" :class="(getNetProfitMoney() > 0) ? 'text-success' : 'text-danger'">{{ getNetProfitMoney() }}</span>
										<span v-if="getPercentageChangeNetProfit('played_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>%{{ getPercentageChangeAmount('played_sport_bet_total_amount') }}</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
							</div>

							<div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.total_profit }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.total_profit"></i>
									</div>
									<div class="balance-value">
										<span class="d-xxl-none">{{ getAmountMoney ('lost_sport_bet_total_amount') }}</span>
										<span class="d-none d-xxl-inline-block":class="(getAmountMoney ('lost_sport_bet_total_amount') > 0) ? 'text-success' : 'text-danger'">{{ getAmountMoney ('lost_sport_bet_total_amount') }}</span>

										<span v-if="getPercentageChangeAmount('lost_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('lost_sport_bet_total_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('lost_sport_bet_total_amount') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('lost_sport_bet_total_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.amount_of_prizes_paid }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_prizes_paid"></i>
									</div>
									<div class="balance-value">
										<span class="d-xxl-none">{{ getAmountMoney ('total_prize_amount') }}</span>
										<span class="d-none d-xxl-inline-block">{{ getAmountMoney ('total_prize_amount') }}</span>

										<span v-if="getPercentageChangeAmount('total_prize_amount') != 0" class="trending" :class="(getPercentageChangeAmount('total_prize_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('total_prize_amount') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('total_prize_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
							</div>
							<div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.amount_of_waiting_waget }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_waiting_waget"></i>
									</div>
									<div class="balance-value">
										<span class="d-xxl-none">{{ getAmountMoney ('waiting_sport_bet_total_amount') }}</span>
										<span class="d-none d-xxl-inline-block">{{ getAmountMoney ('waiting_sport_bet_total_amount') }}</span>

										<span v-if="getPercentageChangeAmount('total_prize_sport_bets_amount') != 0" class="trending" :class="(getPercentageChangeAmount('total_prize_sport_bets_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('total_prize_sport_bets_amount') }%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('total_prize_sport_bets_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
								<div class="balance balance-v2">
									<div class="balance-title">
										{{ t.navigation.amount_of_waiting_prize }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_waiting_prize"></i>
									</div>
									<div class="balance-value">
										<span class="d-xxl-none">{{ getAmountMoney ('waiting_sport_bet_total_prize_amount') }}</span>
										<span class="d-none d-xxl-inline-block">{{ getAmountMoney ('waiting_sport_bet_total_prize_amount') }}</span>

										<span v-if="getPercentageChangeAmount('waiting_sport_bet_total_prize_amount') != 0" class="trending" :class="(getPercentageChangeAmount('waiting_sport_bet_total_prize_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('waiting_sport_bet_total_prize_amount') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('waiting_sport_bet_total_prize_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
									</div>
								</div>
							</div>

						</div>

						<div class="col-sm-12 col-xxl-6">
							<div class="row">
								<div class="col-sm-6 b-r b-b">
									<div class="el-tablo centered p-4">
										<div class="value">
											{{ getCountNformatter ('played_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.navigation.bets }}
										</div>
									</div>
								</div>
								<div class="col-sm-6 b-b">
									<div class="el-tablo centered p-4">
										<div class="value">
											{{ getCountNformatter ('waiting_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.betting.title.waiting_bets }}
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-6 b-r b-b">
									<div class="el-tablo centered p-4">
										<div class="value">
											{{ getCountNformatter ('won_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.betting.title.winning_bets }}
										</div>
									</div>
								</div>
								<div class="col-sm-6 b-b">
									<div class="el-tablo centered p-4">
										<div class="value">
											{{ getCountNformatter ('lost_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.betting.title.losed_bets }}
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-6 b-r">
									<div class="el-tablo centered p-3">
										<div class="value">
											{{ getCountNformatter ('refund_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.betting.title.refunded_bets }}
										</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="el-tablo centered p-3">
										<div class="value">
											{{ getCountNformatter ('cancelled_sport_bet_total_count') }}
										</div>
										<div class="label">
											{{ t.betting.title.cancelled_bets }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="row pt-2">
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.navigation.credits }}
						</div>
						<div class="value" v-tooltip="getAmountMoney('credit_money_amount', 1)">
							{{ getAmountMoney('credit_money_amount') }}
						</div>
						<div v-if="getPercentageChangeAmount('credit_money_amount') != 0" class="trending" :class="(getPercentageChangeAmount('credit_money_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmount('credit_money_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmount('credit_money_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.navigation.affiliate_sharing_profit }}
						</div>
						<div class="value text-danger" v-tooltip="'-'+getAmountMoney('affiliate_sharing_profit_amount', 1)">
							-{{ getAmountMoney('affiliate_sharing_profit_amount') }}
						</div>
						<div v-if="getPercentageChangeAmount('affiliate_sharing_profit_amount') != 0" class="trending" :class="(getPercentageChangeAmount('affiliate_sharing_profit_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmount('affiliate_sharing_profit_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmount('affiliate_sharing_profit_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.betting.title.refunded_bets }}
						</div>
						<div class="value" v-tooltip="getAmountMoney('refunded_sport_bet_total_amount', 1)">
							{{ getAmountMoney('refunded_sport_bet_total_amount') }}
						</div>
						<div v-if="getPercentageChangeAmount('refunded_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('refunded_sport_bet_total_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmount('refunded_sport_bet_total_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmount('refunded_sport_bet_total_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.betting.title.cancelled_bets }}
						</div>
						<div class="value" v-tooltip="getAmountMoney('cancelled_sport_bet_total_amount', 1)">
							{{ getAmountMoney('cancelled_sport_bet_total_amount') }}
						</div>
						<div v-if="getPercentageChangeAmount('cancelled_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('cancelled_sport_bet_total_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmount('cancelled_sport_bet_total_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmount('cancelled_sport_bet_total_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.navigation.average_of_bet }}
						</div>
						<div class="value" v-tooltip="getAmountMoneyAvg('played_sport_bet_total_amount', 1)">
							{{ getAmountMoneyAvg('played_sport_bet_total_amount') }}
						</div>
						<div v-if="getPercentageChangeAmountAvg('played_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmountAvg('played_sport_bet_total_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmountAvg('played_sport_bet_total_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmountAvg('played_sport_bet_total_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
				<div class="col-6 col-sm-3 col-xxl-2">
					<a class="element-box el-tablo centered trend-in-corner smaller" href="#">
						<div class="label">
							{{ t.navigation.average_of_prize }}
						</div>
						<div class="value" v-tooltip="getAmountMoneyAvg('total_prize_sport_bets_amount', 1)">
							{{ getAmountMoneyAvg('total_prize_sport_bets_amount') }}
						</div>
						<div v-if="getPercentageChangeAmountAvg('total_prize_sport_bets_amount') != 0" class="trending" :class="(getPercentageChangeAmountAvg('total_prize_sport_bets_amount') > 0) ? 'trending-up' : 'trending-down'">
							<span>{{ getPercentageChangeAmountAvg('total_prize_sport_bets_amount') }}%</span><i class="os-icon" :class="(getPercentageChangeAmountAvg('total_prize_sport_bets_amount') > 0) ? 'os-icon-arrow-up6' : 'os-icon-arrow-down6'"></i>
						</div>
					</a>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-8">
					<userWidget layout="vertical" :collapsed="false" :title="t.last_activity" :filter="{ per_page: 5, short: 'lastLogin', direction: 'desc', groups: [5,4,3] }" />
					<div class="row">
						<div class="col-12 col-xxl-12">
							<div class="box-style mb-4 px-4">
								<b-tabs>
									<b-tab :title="t.user.add_balance" active class="p-4">
										<moneyTransfer :headerShow="0" />
									</b-tab>

									<b-tab :title="t.send_bonus" class="p-4">
										<bonusTransfer :headerShow="0" />
									</b-tab>
								</b-tabs>
							</div>
							<sessionWidget />
							<activityWidget :filter="{period: selectedAccountingPeriod}" />
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<transactionLast />
				</div>
			</div>

		</div>
		<!--------------------
		START - Sidebar
		-------------------->
		<div class="content-panel compact">
			<div class="content-panel-close" v-on:click="controlPanel()">
				<i class="os-icon os-icon-close"></i>
			</div>

			<div class="element-wrapper">
				<h6 class="element-header">
					{{ t.currency_overview }}
				</h6>
				<div class="element-box-tp">
					<currencyWidget :filter="{period: selectedAccountingPeriod}" />
				</div>
			</div>

			<userWidget :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />

			<userWidget :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />

			<trendWidget />
		</div>
		<!--------------------
		END - Sidebar
		-------------------->


	</div>
</template>

<script>
	import sessionWidget from '@/components/analytics/widget/session'
	import transactionLast from '@/components/accounting/widget/transaction'
    import bonusTransfer from '@/components/accounting/bonusTransfer'
    import moneyTransfer from '@/components/accounting/moneyTransfer'
	import formatter from '@/mixins/formatter'
    import userWidget from '@/components/user/widget/userWidget'
    import activityWidget from '@/components/user/widget/activityWidget'
	import currencyWidget from '@/components/accounting/widget/currency'
    import trendWidget from '@/components/user/bets/widget/trends'

    export default {
        name: 'financialOverview',
	    mixins: [formatter],
	    components: { userWidget, activityWidget, currencyWidget, moneyTransfer, bonusTransfer, trendWidget, transactionLast,
            sessionWidget},
        data () {
            return {
                t: this.$root.t,
                stats: null,
                netProfit: null,
	            stats_10m: null,
	            visitor: null,
	            currency: {
                    id: 0
	            },
                selectedAccountingPeriod: 'today',
                accountingPeriods: [
	                { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ]
            }
        },
	    mounted () {
            this.fetchStats('this_month');

            this.$bus.$on('changeCurrencyAnalytics', (payload) => {
                this.currency = payload;
                this.fetchStats();
            })
        },
        updated () {

        },
	    watch: {
          'selectedAccountingPeriod' () {
              this.fetchStats();
	      },
	    },
	    methods: {

            fetchStats () {
                this.$http.get(api+'api/v1/analytics/general/stats', {params: {period: this.selectedAccountingPeriod, currency: this.currency.id}}).then(response => {
                    // get body data
                    this.stats = response.body.result.stats;
                    this.netProfit = response.body.result.net_profit;
                    this.currency = response.body.result.currency;

                    var th = this;

                }, response => {

                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/financial.vue